import React from 'react'
import BarChartSkeleton from './BarChartSkeleton'

const SkeletonClassroomChartHeader = () => {
    return (
        <>
            <div className="w-full flex flex-row gap-[15px] items-center justify-between h-10 animate-pulse">
                <div className="h-[38px] w-[280px] bg-lightBG rounded" />
                <div className="flex flex-row items-center gap-3">
                    <div className="w-[38px] h-[38px] bg-lightBG rounded-full"></div>
                    <div className="h-[38px] w-[150px] bg-lightBG rounded-full " />
                    <div className="w-[38px] h-[38px] bg-lightBG rounded-full"></div>
                </div>
                <div className="h-10 max-w-[210px] flex-1 bg-lightBG rounded-full" />
                <div className="h-10 w-[190px] bg-lightBG rounded-full" />
                <div className="h-10 w-[140px] bg-lightBG rounded-full" />
                <div className="h-10 w-[200px] bg-lightBG rounded-full" />
            </div>
            <div className="w-full mt-8 animate-pulse">
                <p className=" h-5 w-[600px] bg-lightBG rounded"></p>
            </div>
            <div className=" animate-pulse" style={{ width: '100%', marginTop: 16, position: 'relative' }}>
                <BarChartSkeleton />
            </div>
        </>
    )
}

export default SkeletonClassroomChartHeader
